var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconParticipantActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E1EAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F7F9FD",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.8828 26.4117H25.4618C27.5598 26.4117 28.7389 24.1685 26.9928 23.0055C26.2919 22.5388 25.5282 22.1592 24.7169 21.8822",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9655 18.9717C21.3292 19.0673 21.733 19.1161 22.1749 19.1161C24.4222 19.1161 25.6863 17.852 25.6863 15.6046C25.6863 13.3573 24.4222 12.0931 22.1749 12.0931C22.1487 12.0931 22.1226 12.0933 22.0967 12.0937",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0392 22.7208C23.9315 23.9812 22.6537 26.4117 20.3802 26.4117H11.8426C9.56908 26.4117 8.29135 23.9812 10.1836 22.7208C11.8808 21.5904 13.9192 20.9316 16.1114 20.9316C18.3036 20.9316 20.342 21.5904 22.0392 22.7208Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1142 18.4313C18.59 18.4313 19.9826 17.0387 19.9826 14.563C19.9826 12.0872 18.59 10.6946 16.1142 10.6946C13.6385 10.6946 12.2459 12.0872 12.2459 14.563C12.2459 17.0387 13.6385 18.4313 16.1142 18.4313Z",
    fill: "#C6D8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0392 22.7208C23.9315 23.9812 22.6537 26.4117 20.3802 26.4117H11.8426C9.56908 26.4117 8.29135 23.9812 10.1836 22.7208C11.8808 21.5904 13.9192 20.9316 16.1114 20.9316C18.3036 20.9316 20.342 21.5904 22.0392 22.7208Z",
    fill: "#C6D8F8",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1142 18.4313C18.59 18.4313 19.9826 17.0387 19.9826 14.563C19.9826 12.0872 18.59 10.6946 16.1142 10.6946C13.6385 10.6946 12.2459 12.0872 12.2459 14.563C12.2459 17.0387 13.6385 18.4313 16.1142 18.4313Z",
    stroke: "#4475CD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconParticipantActivity);
export default __webpack_public_path__ + "static/media/MetricIconParticipant-activity.928f105360267dd8b77f55cc09eff893.svg";
export { ForwardRef as ReactComponent };